const Created = "created";
const Ordered = "ordered";
const Paid = "paid";
const Invalid = "invalid";
const ACTUAL_RESULT = "actual_result";

function all(): string[] {
  return [Created, Ordered, Paid, Invalid];
}

export default {
  Created,
  Ordered,
  Paid,
  Invalid,
  ACTUAL_RESULT,
  all
};
